import Box from '@components/Box';
import { Column, Row } from '@components/Grid';
import { IPlacingOrderTitleProps } from '../types';
import { Text, TextType } from '@components/Text';

const PlacingOrderTitle: React.FC<IPlacingOrderTitleProps> = (props: IPlacingOrderTitleProps): React.ReactElement => {
  const { title } = props;

  return (
      <Row>
        <Column phone={12}>
          <Box mb={5}>
            <Text type={TextType.H3}>
              {title}
            </Text>
          </Box>
        </Column>
      </Row>
  );
};

export default PlacingOrderTitle;